/** @format */

import React, {useContext, useReducer, useEffect, useCallback} from 'react';
import {useRouter} from 'next/router';

import {pageUrl, requestData} from '@utils/product';
import {reducer} from '@reducers/product/list';
import {api} from '@utils/api';

const ShippingContext = React.createContext();
export const ShippingProvider = ({children, props}) => {
	const [state, dispatch] = useReducer(reducer, {
		filters: [],
		shippings: [],
	});

	const router = useRouter();

	const loadStores = useCallback(async () => {
		const {shippings} = await api({
			url: '/product/shippings',
			method: 'POST',
			data: {
				...requestData({
					filters: {
						brand: props.filters.brand,
						category: props.filters.category,
						retailer: props.filters.retailer,
						name: props.filters.name,
						 
						price_from: props.filters.price_from,
						 
						price_to: props.filters.price_to,
						shipping: props.filters.shipping,
					},
					category: props.category,
					brand: props.brand,
				}).filter,
			},
		});
		if (props.filters.shipping) {
			let selected = props.filters.shipping.split('|');
			let filters = [];
			selected.map(sr =>
				filters.push({
					_id: sr,
					label:
						sr === 'ship_to_nz' ? 'Ship to NewZealand' : 'Ship to Australia',
					type: 'shipping',
				}),
			);
			dispatch({
				type: 'SET_DATA',
				data: {
					filters,
					shippings,
				},
			});
		} else {
			dispatch({
				type: 'SET_DATA',
				data: {
					filters: [],
					shippings,
				},
			});
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		props.filters.brand,
		props.filters.category,
		props.category,
		props.brand,
		props.filters.price_from,
		props.filters.price_to,
		props.filters.name,
		props.filters.options,
		props.filters.shipping,
		props.filters.retailer,
	]);

	useEffect(() => {
		loadStores();
	}, [loadStores]);

	const updateFilter = (filters, push = true) => {
		dispatch({
			type: 'SET_DATA',
			data: {
				filters,
			},
		});
		let shipping = filters.map(ft => ft._id).join('|');
		let query = props.filters;
		if (shipping) {
			query.shipping = shipping;
		} else {
			delete query.shipping;
		}

		delete query.page;
		if (push) {
			router.push({
				pathname: pageUrl(props),
				query,
			});
		}
	};

	return (
		<ShippingContext.Provider
			value={{
				filters: state.filters,
				loading: state.loading,
				shippings: state.shippings,
				updateFilter,
			}}
		>
			{children}
		</ShippingContext.Provider>
	);
};

export function useShipping() {
	const context = useContext(ShippingContext);
	if (context === undefined) {
		throw new Error('useShipping must be used within a ShippingProvider');
	}
	return context;
}
